export default {
  defaultTitle: {
    en: 'Add to cart',
  },
}
